// tslint:disable-next-line:no-implicit-dependencies
import {Subject, Subscription} from "rxjs";

export interface DateRange {
    start: Date;
    end: Date;
}

export interface RangedDatePickerControllerKWArgs {
    startDate?: Date;
    endDate?: Date;
}

export default class RangedDatePickerController {

    public startDate: Date;
    public endDate: Date;

    private rangeSubject: Subject<DateRange>;

    constructor(kwargs: RangedDatePickerControllerKWArgs) {
        this.startDate = kwargs.startDate;
        this.endDate = kwargs.endDate;
        this.rangeSubject = new Subject<DateRange>();
    }

    public listen(listener: (range: DateRange) => void): Subscription {
        return this.rangeSubject.subscribe(listener);
    }

    public dispose() {
        this.rangeSubject.unsubscribe();
    }

    public changeRange(start: Date, end: Date) {
        this.startDate = start;
        this.endDate = end;
        this.rangeSubject.next({ start, end });
    }
}
